import {AclUser} from './app-user';
import {Timestamp} from 'firebase/firestore';
import {Activity} from './activity';

import {ResumeMaterial} from './material';



export enum SearchModes {
    SLOW = 'slow',
    QUICK = 'quick'
}


export interface Budget {
    allOffers?: { offerUrl: string, companyName: string, amount: number }[];
    id: string;
    version: 'v1' | 'v2';
    budgetNr: string;
    budgetName: string | null;
    searchMode: SearchModes;
    author: Partial<AclUser>;
    dummy?: boolean;
    assignee: {
        displayName: string;
        googleUid: string;
        id: string;
        on: Date | Timestamp;
    };
    category: string;
    clientId: string;
    creation: Date;
    description: string;
    tags: string[];
    status: string;
    deliveryThr?: Date | Timestamp;
    offerUrl?: string;
    driveFolderId?: string;
    project?: Project;
    margin?: MarginV1 | MarginV2;
    assemblyCosts?: AssemblyCosts;
    offer?: Offer;
    modifiedBy?: Partial<AclUser>;
    modifiedOn?: Date;
    costSummary?: CostSummary;
    splittedCostSummary: SplittedCostTableElementV1[] | SplittedCostTableElementV2[];
    export?: any;
    exportBudget?: any;
    paymentStatus?: any;
    reportSummary?: any;
    filter?: string[];
    archivedDate?: Date;

    authGrants: { [key: string]: string | Timestamp | null };

    // @Deprecated by authGrants
    authorizedModify?: string;
    // @Deprecated by authGrants
    authorizedModifyDate?: Date | Timestamp;

    offerDestinationFolderId?: string;

    imported?: boolean;
    offerDate?: Date;
    budgetCostTotal?: string;
    budgetHoursTotal?: string;
    budgetMaterialsTotal?: string;
    projectManager?: string;
    ref?: string;
    salesManager?: string;
    workerList?: boolean;
    reopened?: { userId: string, date: any };

    cosmoId?: { cosmoId: string };
    capitalImprovement?: boolean;

    scope?: string[];
    opportunityIds: string[];
    company: {
        companyName: string;
        companyId: string | number;
        cosmoId: string | null;
    };

    reportSent?: boolean; // if the final PDF report has been sent or not
    internalFolderId?: string;
    companyAssignee?: string;
}

export interface ExportData {
    currency: string;
    exchangeRate: number;
    exRateUpdateDate?: Date;
}


export interface Offer {
    offerAmount: number;
    offerAmountShown?: number;
    shippingAmount: number;
    designAmount: number;
    productionAmount: number;
    assemblyAmount: number;
}


export interface Project {
    projectManager: {
        displayName: string;
        id: Partial<AclUser>;
    };
    projectNr: string;

    finalInvoiced?: number;
    finalOfferOrder: number;
    finalOfferOrderChanges: { user: string, date: Date }[];

    user?: string;
    internal?: boolean;
    promo?: boolean;


    deliveryDate?: Date;
    openProjectDate: Date;

    paymentMethod: string;
    paymentMethodCode: string;
}


export interface MarginV1 {
    generalExpenses: number;
    profit: number;
    commission: number;
    customDuties: number;
}

export interface MarginV2 {
    generalExpenses: number;
    ciTaxesPercentage: number;
    profit: number;
    capitalImprovement: boolean;
    commission: number;
}


export interface AssemblyCosts {
    employee: number;
    projectManager: number;
    employeeDays: number;
    projectManagerDays: number;
    employeeCost: number;
    projectMangerCost: number;
    travelExpensesAccomodation: number;
    travelExpensesFlights: number;
    renting: number;
    externalManpower: number;
    other: number[];
}


export interface SplittedCostTableElementV1 {
    id: string;
    name: string;
    cost: number;
    commission: number;
    customDuties: number;
    profit: number;
    expenses: number;
    total: number;
    totalEuro?: number;
    hint?: string;
}

export interface SplittedCostTableElementV2 {
    id: string;
    name: string;
    cost: number;
    commission: number;
    profit: number;
    expenses: number;
    taxes: number;
    total: number;
    totalEuro?: number;
    totalWithTaxes?: number;
    hint?: string;
}


export interface OfferTemplate {
    id: string;
    name: string;
    locale?: string;
    lang: string;
    templateId: string;
}

export interface CostSummary {
    total: number;
    goods: number;
    goodsValue: number;
    hours: number; // espresso in ore
    hoursValue: number; // espresso in euro
    production: number;
    productionFinal: number;
    design: number;
    shipping: number;
    assembly: number;
    customDuties: number;
}

export interface BudgetSummary {
    materials: Array<ResumeMaterial>;
    activities: Array<Activity>;
    spreadsheetId?: string;
    generateSheet?: boolean;
}
